<template>
	<div class="overflow-auto min-h-1 max-h-[460px] mb-[30px]">
		<div
			v-for="(event, index) in events"
			:key="index"
			class="flex justify-between border-b border-[#EBEBEB] content-center cursor-pointer hover:bg-[#f5f5f5] pl-2"
			@click="() => $emit('openEvent', event)"
		>
			<div class="text-[14px] py-[15px]">{{ event.title }}</div>
			<AppDropdownMenu v-if="!event.is_default" left bottom absolute min-width="200" content-class="men" :items="menuItems[index]">
				<template #activator>
					<AnemicButton @click="(e) => e.preventDefault()" width="22" height="22" icon fab x-small class="flex-centerize menu-button mr-2">
						<AppIcon name="three-dot-menu" width="13" class="menu-icon" />
					</AnemicButton>
				</template>
				<template #list-item="{ item }">
					<span class="text-[14px] text-[#3e495a]">
						{{ item.text }}
					</span>
				</template>
			</AppDropdownMenu>
		</div>
		<div v-if="isEmpty" class="text-center my-[20px]">Add your first event.</div>
	</div>
</template>

<script>
import AppIcon from '@/components/atoms/AppIcon.vue';

export default {
	name: 'EventList',
	components: {
		AppIcon,
	},
	props: {
		events: { type: Array, required: true },
	},
	computed: {
		menuItems() {
			return this.events.map((event) => {
				const item = [
					{
						onClick: () => {
							this.$emit('openEvent', event);
						},
						text: 'Edit',
					},
				];
				if (!event.is_default) {
					item.push({
						onClick: () => {
							this.$emit('deleteEvent', event);
						},
						text: 'Delete',
					});
				}
				return item;
			});
		},
		isEmpty() {
			return this.events.length === 0;
		},
	},
	methods: {},
};
</script>

<style scoped lang="scss">
::v-deep {
	.flex.justify-between.border-b > div {
		display: grid;
		place-content: center;
	}
}
</style>
